






import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import SmartFormField from "./SmartFormField.vue";
import {copy, deepCopy, deepMerge, dotFlatten, dotUnflatten, equals, leafNuller, removeNull} from "../utils";

@Component({
  components: {SmartFormField},
})

export default class SmartForm extends Vue {
  // v-model binding
  @Prop({
    default: () => {
      return {}
    }
  }) public readonly value: any

  @Prop() public readonly schema: any

  public finalItem: any = {}

  mounted() {

    // Initialize final item
    //this.finalItem = Object.assign(this.finalItem, this.value)
    this.initFinalItem()
    //this.valueChanged(this.value, null) //inutile perche initFinalItem fa tutto
  }

  public initFinalItem() {
    this.finalItem = leafNuller(deepCopy(this.schema));
    this.finalItem = Object.assign(this.finalItem, this.value)
  }

  // Reactive loop updater
  @Watch('value', {
    deep: false
  })
  public valueChanged(newValue: any, oldValue: any) {
    if (oldValue && !equals(newValue, oldValue)) {
      //this.finalItem = Object.assign(this.finalItem, newValue)
      this.finalItem = Object.assign(leafNuller(copy(this.schema)), newValue)
      //necessary to display null fields in case edit
      //Object.keys(this.finalItem).forEach(k=> {
      //  this.finalItem[k] = newValue[k] ? newValue[k] : this.finalItem[k]
      //})

    }

  }

  @Watch('finalItem', {
    deep: false
  })
  public sendUpdate() {
    this.$emit('input', this.finalItem)
  }

  get options() {
    return {
      schema: dotFlatten(this.schema)
    }
  }
}

